import { action } from 'satcheljs';
import { OWAConnectedAccount, OWAConnectedAccountState } from './schema/OWAConnectedAccount';

/**
 * Adds an account to the store.
 * The store responds by loading the user configuration of this account.
 */
export const addOWAConnectedAccount = action('addAccount', (account: OWAConnectedAccount) => ({
    userIdentity: account.userIdentity,
    account,
}));

/**
 * Removes an account to the store.
 */
export const removeOWAConnectedAccount = action('removeAccount', (userIdentity: string) => ({
    userIdentity,
}));

/**
 * Updates an account to the store.
 */
export const updateOWAConnectedAccountToken = action(
    'updateAccount',
    (userIdentity: string, accountToken: string, accountTokenExpiresIn: string) => ({
        userIdentity: userIdentity,
        accountToken: accountToken,
        accountTokenExpiresIn: accountTokenExpiresIn,
    })
);

/**
 * Updates the OWA Connected account status
 */
export const updateOWAConnectedAccountStatus = action(
    'updateOWAConnectedAccountStatus',
    (userIdentity: string, accountState: OWAConnectedAccountState) => ({
        userIdentity,
        accountState,
    })
);

/**
 * Triggered whenever account is determined to be in error state
 */
export const accountIsInErrorState = action(
    'accountIsInErrorState',
    (accountState: OWAConnectedAccountState) => ({ accountState })
);
